



















































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { AccountActions, Action } from '@/models'
import { ACCOUNT_PROFILE_ADMIN } from '@/utils/constants'
import { Utils } from '@/utils'

@Component({
  components: {}
})
export default class AccountActionsComponent extends Vue {
  private ACCOUNT_PROFILE_ADMIN = ACCOUNT_PROFILE_ADMIN

  @Prop({ required: true }) actions!: AccountActions[]
  @Prop({ required: true }) allActions!: Action[]

  private selectedActionIds: string[] = []
  private addingActions = false
  private searchFilter = ''
  private actionsCurrentPage = 1
  private actionsPerPage = 10

  private actionsFields = [
    {
      key: 'description',
      label: this.$t('account_detail.actions.columns.description'),
      sortable: true
    },
    {
      key: 'createdOn',
      label: this.$t('account_detail.actions.columns.created_on'),
      sortable: true
    },
    {
      key: 'actions',
      label: this.$t('table.actions'),
      sortable: false,
      class: 'text-center'
    }
  ]

  get availableActions(): Action[] {
    const assignedActionIds = this.actions.map(a => a.actionsId)
    return this.allActions.filter(action => !assignedActionIds.includes(action.actionsId))
      .sort((a, b) => a.description.localeCompare(b.description))
  }

  get hasSearchFilter(): boolean {
    return this.searchFilter.trim() !== ''
  }

  get filteredActions(): AccountActions[] {
    if (!this.hasSearchFilter) return this.actions
    const filterNormalized = Utils.normalizeText(this.searchFilter)
    return this.actions.filter(action => {
      const descriptionNormalized = Utils.normalizeText(this.getActionDescription(action.actionsId))
      return descriptionNormalized.includes(filterNormalized)
    })
  }

  get actionsPaginated(): AccountActions[] {
    const start = (this.actionsCurrentPage - 1) * this.actionsPerPage
    const end = start + this.actionsPerPage
    return this.filteredActions.slice(start, end)
  }

  @Watch('searchFilter')
  onSearchFilterChange() {
    this.actionsCurrentPage = 1
  }

  getActionDescription(actionsId: string): string {
    const action = this.allActions.find(a => a.actionsId === actionsId)
    return action ? action.description : actionsId
  }

  handleAddActions() {
    this.$emit('add-actions', {
      selectedActionIds: this.selectedActionIds,
      setAdding: (value: boolean) => { this.addingActions = value },
      clearSelection: () => { this.selectedActionIds = [] }
    })
  }

  handleDeleteAction(accountAction: AccountActions) {
    this.$emit('delete-action', accountAction)
  }

  handleDeleteAllActions() {
    this.$emit('delete-all-actions')
  }
}
